import { render, staticRenderFns } from "./ModalRemoveAttribute.vue?vue&type=template&id=7bca1c71&"
import script from "./ModalRemoveAttribute.vue?vue&type=script&lang=js&"
export * from "./ModalRemoveAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports